import Footer from "../components/footer";
import Header from "../components/header";
import SeoLinksSection from "../components/SeoLinksSection";

export default function Home4() {
  return (
    <>
      <Header />
      <>
        {/* banner starts */}
        <div className="banner trending overflow-hidden">
          <div className="banner-main">
            <div className="row banner-slider">
              <div className="col-lg-4 p-0">
                <div className="trend-item1 box-shadow bg-white text-center">
                  <div className="trend-image position-relative">
                    <img
                      src="images/new-deal/deal1.jpg"
                      alt="image"
                      className=""
                    />
                    <div className="trend-content1 px-4 top-50 bottom-inherit translatey-50">
                      <h5 className="theme1 mb-0">
                        <i className="flaticon-location-pin" /> Norway
                      </h5>
                      <h2 className="mb-1 white">
                        <a href="grid-leftfilter.html" className="white">
                          Norway Lake
                        </a>
                      </h2>
                      <div className="rating-main pb-1">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="ms-2 white">(16)</span>
                        </div>
                      </div>
                      <div className="entry-meta text-center">
                        <div className="entry-author mb-1">
                          <p className="mb-0 white">
                            <span className="theme1 fw-bold fs-5">
                              {" "}
                              $180.00
                            </span>{" "}
                            | Per person
                          </p>
                        </div>
                        <div className="entry-author">
                          <i className="icon-calendar white" />
                          <span className="fw-bold white"> 6 Days Tours</span>
                        </div>
                      </div>
                    </div>
                    <div className="overlay" />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 p-0">
                <div className="trend-item1 box-shadow bg-white text-center">
                  <div className="trend-image position-relative">
                    <img
                      src="images/new-deal/deal2.jpg"
                      alt="image"
                      className=""
                    />
                    <div className="trend-content1 px-4 top-50 bottom-inherit translatey-50">
                      <h5 className="theme1 mb-0">
                        <i className="flaticon-location-pin" /> Moscow
                      </h5>
                      <h2 className="mb-1 white">
                        <a href="grid-leftfilter.html" className="white">
                          Capital Tour
                        </a>
                      </h2>
                      <div className="rating-main pb-1">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="ms-2 white">(21)</span>
                        </div>
                      </div>
                      <div className="entry-meta text-center">
                        <div className="entry-author mb-1">
                          <p className="mb-0 white">
                            <span className="theme1 fw-bold fs-5">
                              {" "}
                              $240.00
                            </span>{" "}
                            | Per person
                          </p>
                        </div>
                        <div className="entry-author">
                          <i className="icon-calendar white" />
                          <span className="fw-bold white"> 5 Days Tours</span>
                        </div>
                      </div>
                    </div>
                    <div className="overlay" />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 p-0">
                <div className="trend-item1 box-shadow bg-white text-center">
                  <div className="trend-image position-relative">
                    <img
                      src="images/new-deal/deal3.jpg"
                      alt="image"
                      className=""
                    />
                    <div className="trend-content1 px-4 top-50 bottom-inherit translatey-50">
                      <h5 className="theme1 mb-0">
                        <i className="flaticon-location-pin" /> Italy
                      </h5>
                      <h2 className="mb-1 white">
                        <a href="grid-leftfilter.html" className="white">
                          Rome Historical
                        </a>
                      </h2>
                      <div className="rating-main pb-1">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="ms-2 white">(18)</span>
                        </div>
                      </div>
                      <div className="entry-meta text-center">
                        <div className="entry-author mb-1">
                          <p className="mb-0 white">
                            <span className="theme1 fw-bold fs-5">
                              {" "}
                              $190.00
                            </span>{" "}
                            | Per person
                          </p>
                        </div>
                        <div className="entry-authorr">
                          <i className="icon-calendar white" />
                          <span className="fw-bold white"> 9 Days Tours</span>
                        </div>
                      </div>
                    </div>
                    <div className="overlay" />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 p-0">
                <div className="trend-item1 box-shadow bg-white text-center">
                  <div className="trend-image position-relative">
                    <img
                      src="images/new-deal/deal4.jpg"
                      alt="image"
                      className=""
                    />
                    <div className="trend-content1 px-4 top-50 bottom-inherit translatey-50">
                      <h5 className="theme1 mb-0">
                        <i className="flaticon-location-pin" /> America
                      </h5>
                      <h2 className="mb-1 white">
                        <a href="grid-leftfilter.html" className="white">
                          Golden Gate
                        </a>
                      </h2>
                      <div className="rating-main pb-1">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="ms-2 white">(34)</span>
                        </div>
                      </div>
                      <div className="entry-meta text-center">
                        <div className="entry-author mb-1">
                          <p className="mb-0 white">
                            <span className="theme1 fw-bold fs-5">
                              {" "}
                              $310.00
                            </span>{" "}
                            | Per person
                          </p>
                        </div>
                        <div className="entry-author">
                          <i className="icon-calendar white" />
                          <span className="fw-bold white"> 10 Days Tours</span>
                        </div>
                      </div>
                    </div>
                    <div className="overlay" />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 p-0">
                <div className="trend-item1 box-shadow bg-white text-center">
                  <div className="trend-image position-relative">
                    <img
                      src="images/new-deal/deal5.jpg"
                      alt="image"
                      className=""
                    />
                    <div className="trend-content1 px-4 top-50 bottom-inherit translatey-50">
                      <h5 className="theme1 mb-0">
                        <i className="flaticon-location-pin" /> Austria
                      </h5>
                      <h2 className="mb-1 white">
                        <a href="grid-leftfilter.html" className="white">
                          Vienna, Hallstatt
                        </a>
                      </h2>
                      <div className="rating-main pb-1">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="ms-2 white">(22)</span>
                        </div>
                      </div>
                      <div className="entry-meta text-center">
                        <div className="entry-author mb-1">
                          <p className="mb-0 white">
                            <span className="theme1 fw-bold fs-5">
                              {" "}
                              $150.00
                            </span>{" "}
                            | Per person
                          </p>
                        </div>
                        <div className="entry-author">
                          <i className="icon-calendar white" />
                          <span className="fw-bold white"> 3 Days Tours</span>
                        </div>
                      </div>
                    </div>
                    <div className="overlay" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* banner ends */}
        {/* form main starts */}
        <div className="form-main">
          <div
            className="section-shape section-shape1 top-0"
            style={{ backgroundImage: "url(images/shape8.png)" }}
          />
          <div className="container">
            <div className="row align-items-center form-content rounded position-relative ms-5 me-5">
              <div className="col-lg-2 p-0">
                <h4 className="form-title1 text-center p-4 py-5 white bg-theme mb-0 rounded-start d-lg-flex align-items-center">
                  <i className="icon-location-pin fs-1 me-1" /> Find Your
                  Holidays
                </h4>
              </div>
              <div className="col-lg-10 px-4">
                <div className="form-content-in d-lg-flex align-items-center">
                  <div className="form-group me-2">
                    <div className="input-box">
                      <select className="niceSelect">
                        <option value={1}>Destination</option>
                        <option value={2}>Argentina</option>
                        <option value={3}>Belgium</option>
                        <option value={4}>Canada</option>
                        <option value={5}>Denmark</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group me-2">
                    <div className="input-box">
                      <input type="date" name="date" />
                    </div>
                  </div>
                  <div className="form-group me-2">
                    <div className="input-box">
                      <select className="niceSelect">
                        <option value={1}>Travel Type</option>
                        <option value={2}>City Tour</option>
                        <option value={3}>Family Tour</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group me-2">
                    <div className="input-box">
                      <select className="niceSelect">
                        <option value={1}>Tour Duration</option>
                        <option value={2}>5 days</option>
                        <option value={3}>7 Days</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group mb-0 text-center">
                    <a href="#" className="nir-btn w-100">
                      <i className="fa fa-search mr-2" /> Search Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* form main ends */}
        {/* about-us starts */}
        <section
          className="about-us pb-6"
          style={{
            backgroundImage: "url(images/shape4.png)",
            backgroundPosition: "center",
          }}
        >
          <div className="container">
            <div className="section-title mb-6 w-50 mx-auto text-center">
              <h4 className="mb-1 theme1">Core Features</h4>
              <h2 className="mb-1">
                Find <span className="theme">Travel Perfection</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            {/* why us starts */}
            <div className="why-us">
              <div className="why-us-box">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                    <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                      <div className="why-us-content">
                        <div className="why-us-icon mb-1">
                          <i className="icon-flag theme" />
                        </div>
                        <h4>
                          <a href="about.html">Tell Us What You want To Do</a>
                        </h4>
                        <p className="mb-2">
                          Excepteur sint occaecat cupidatat non proident, sunt
                          in culpa qui officia.
                        </p>
                        <p className="mb-0 theme">100+ Reviews</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                    <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                      <div className="why-us-content">
                        <div className="why-us-icon mb-1">
                          <i className="icon-location-pin theme" />
                        </div>
                        <h4>
                          <a href="about.html">Share Your Travel Locations</a>
                        </h4>
                        <p className="mb-2">
                          Excepteur sint occaecat cupidatat non proident, sunt
                          in culpa qui officia.
                        </p>
                        <p className="mb-0 theme">100+ Reviews</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                    <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                      <div className="why-us-content">
                        <div className="why-us-icon mb-1">
                          <i className="icon-directions theme" />
                        </div>
                        <h4>
                          <a href="about.html">Share Your Travel Preference</a>
                        </h4>
                        <p className="mb-2">
                          Excepteur sint occaecat cupidatat non proident, sunt
                          in culpa qui officia.
                        </p>
                        <p className="mb-0 theme">100+ Reviews</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                    <div className="why-us-item p-5 pt-6 pb-6 border rounded bg-white">
                      <div className="why-us-content">
                        <div className="why-us-icon mb-1">
                          <i className="icon-compass theme" />
                        </div>
                        <h4>
                          <a href="about.html">Here 100% Trusted Tour Agency</a>
                        </h4>
                        <p className="mb-2">
                          Excepteur sint occaecat cupidatat non proident, sunt
                          in culpa qui officia.
                        </p>
                        <p className="mb-0 theme">100+ Reviews</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* why us ends */}
          </div>
          <div className="white-overlay" />
        </section>
        {/* about-us ends */}
        {/* top Destination starts */}
        <section
          className="trending pb-0 pt-0"
          style={{
            backgroundImage: "url(images/shape-1.png)",
            backgroundPosition: "center",
          }}
        >
          <div className="container">
            <div className="section-title mb-6 w-50 mx-auto text-center">
              <h4 className="mb-1 theme1">Top Destinations</h4>
              <h2 className="mb-1">
                Explore <span className="theme">Top Destinations</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-5 mb-4">
                <div className="trend-item1">
                  <div className="trend-image position-relative rounded">
                    <img
                      src="images/destination/destination1.jpg"
                      alt="image"
                    />
                    <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                      <div className="trend-content-title">
                        <h5 className="mb-0">
                          <a href="grid-leftfilter.html" className="theme1">
                            England
                          </a>
                        </h5>
                        <h3 className="mb-0 white">London</h3>
                      </div>
                      <span className="white bg-theme p-1 px-2 rounded">
                        15 Tours
                      </span>
                    </div>
                    <div className="color-overlay" />
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="trend-item1">
                      <div className="trend-image position-relative rounded">
                        <img
                          src="images/destination/destination17.jpg"
                          alt="image"
                        />
                        <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                          <div className="trend-content-title">
                            <h5 className="mb-0">
                              <a href="grid-leftfilter.html" className="theme1">
                                Italy
                              </a>
                            </h5>
                            <h3 className="mb-0 white">Caspian Valley</h3>
                          </div>
                          <span className="white bg-theme p-1 px-2 rounded">
                            18 Tours
                          </span>
                        </div>
                        <div className="color-overlay" />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="trend-item1">
                      <div className="trend-image position-relative rounded">
                        <img
                          src="images/destination/destination14.jpg"
                          alt="image"
                        />
                        <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                          <div className="trend-content-title">
                            <h5 className="mb-0">
                              <a href="grid-leftfilter.html" className="theme1">
                                Tokyo
                              </a>
                            </h5>
                            <h3 className="mb-0 white">Japan</h3>
                          </div>
                          <span className="white bg-theme p-1 px-2 rounded">
                            21 Tours
                          </span>
                        </div>
                        <div className="color-overlay" />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="trend-item1">
                      <div className="trend-image position-relative rounded">
                        <img
                          src="images/destination/destination15.jpg"
                          alt="image"
                        />
                        <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100">
                          <div className="trend-content-title">
                            <h5 className="mb-0">
                              <a href="grid-leftfilter.html" className="theme1">
                                Moscow
                              </a>
                            </h5>
                            <h3 className="mb-0 white">Russia</h3>
                          </div>
                          <span className="white bg-theme p-1 px-2 rounded">
                            15 Tours
                          </span>
                        </div>
                        <div className="color-overlay" />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-4">
                    <div className="trend-item1">
                      <div className="trend-image position-relative rounded">
                        <img
                          src="images/destination/destination16.jpg"
                          alt="image"
                        />
                        <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                          <div className="trend-content-title">
                            <h5 className="mb-0">
                              <a href="grid-leftfilter.html" className="theme1">
                                Florida
                              </a>
                            </h5>
                            <h3 className="mb-0 white">America</h3>
                          </div>
                          <span className="white bg-theme p-1 px-2 rounded">
                            32 Tours
                          </span>
                        </div>
                        <div className="color-overlay" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* top Destination ends */}
        {/* best tour Starts */}
        <section className="trending pb-0">
          <div className="container">
            <div className="section-title text-center w-75 mx-auto mb-6">
              <h4 className="mb-1 theme1">Top Pick</h4>
              <h2 className="mb-1">
                Best <span className="theme">Tour Packages</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="trend-box">
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <div className="trend-item rounded box-shadow">
                    <div className="trend-image position-relative">
                      <img
                        src="images/trending/trending2.jpg"
                        alt="image"
                        className=""
                      />
                      <div className="color-overlay" />
                    </div>
                    <div className="trend-content p-4 pt-5 position-relative">
                      <div className="trend-meta bg-theme white px-3 py-2 rounded">
                        <div className="entry-author">
                          <i className="icon-calendar" />
                          <span className="fw-bold"> 9 Days Tours</span>
                        </div>
                      </div>
                      <h5 className="theme mb-1">
                        <i className="flaticon-location-pin" /> Croatia
                      </h5>
                      <h3 className="mb-1">
                        <a href="grid-leftfilter.html">Piazza Castello</a>
                      </h3>
                      <div className="rating-main d-flex align-items-center pb-2">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                        </div>
                        <span className="ms-2">(12)</span>
                      </div>
                      <p className="border-b pb-2 mb-2">
                        Duis aute irure dolor in reprehenderit in voluptate
                        velit esse cillum
                      </p>
                      <div className="entry-meta">
                        <div className="entry-author d-flex align-items-center">
                          <p className="mb-0">
                            <span className="theme fw-bold fs-5"> $170.00</span>{" "}
                            | Per person
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <div className="trend-item box-shadow rounded">
                    <div className="trend-image position-relative">
                      <img src="images/trending/trending3.jpg" alt="image" />
                      <div className="color-overlay" />
                    </div>
                    <div className="trend-content p-4 pt-5 position-relative">
                      <div className="trend-meta bg-theme white px-3 py-2 rounded">
                        <div className="entry-author">
                          <i className="icon-calendar" />
                          <span className="fw-bold"> 9 Days Tours</span>
                        </div>
                      </div>
                      <h5 className="theme mb-1">
                        <i className="flaticon-location-pin" /> Greece
                      </h5>
                      <h3 className="mb-1">
                        <a href="grid-leftfilter.html">Santorini, Oia</a>
                      </h3>
                      <div className="rating-main d-flex align-items-center pb-2">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                        </div>
                        <span className="ms-2">(38)</span>
                      </div>
                      <p className="border-b pb-2 mb-2">
                        Duis aute irure dolor in reprehenderit in voluptate
                        velit esse cillum
                      </p>
                      <div className="entry-meta">
                        <div className="entry-author d-flex align-items-center">
                          <p className="mb-0">
                            <span className="theme fw-bold fs-5"> $180.00</span>{" "}
                            | Per person
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 mb-4">
                  <div className="trend-item box-shadow rounded">
                    <div className="trend-image position-relative">
                      <img src="images/trending/trending4.jpg" alt="image" />
                      <div className="color-overlay" />
                    </div>
                    <div className="trend-content p-4 pt-5 position-relative">
                      <div className="trend-meta bg-theme white px-3 py-2 rounded">
                        <div className="entry-author">
                          <i className="icon-calendar" />
                          <span className="fw-bold"> 9 Days Tours</span>
                        </div>
                      </div>
                      <h5 className="theme mb-1">
                        <i className="flaticon-location-pin" /> Maldives
                      </h5>
                      <h3 className="mb-1">
                        <a href="grid-leftfilter.html">Hurawalhi Island</a>
                      </h3>
                      <div className="rating-main d-flex align-items-center pb-2">
                        <div className="rating">
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                          <span className="fa fa-star checked" />
                        </div>
                        <span className="ms-2">(18)</span>
                      </div>
                      <p className="border-b pb-2 mb-2">
                        Duis aute irure dolor in reprehenderit in voluptate
                        velit esse cillum
                      </p>
                      <div className="entry-meta">
                        <div className="entry-author d-flex align-items-center">
                          <p className="mb-0">
                            <span className="theme fw-bold fs-5"> $260.00</span>{" "}
                            | Per person
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 text-center">
                  <a href="#" className="nir-btn">
                    View All Packages
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* best tour Ends */}
        {/* Last Minute Deal Starts */}
        <section
          className="trending pb-0"
          style={{ backgroundImage: "url(images/shape2.png)" }}
        >
          <div className="container">
            <div className="section-title mb-6 w-75 mx-auto text-center">
              <h4 className="mb-1 theme1">Top Deals</h4>
              <h2 className="mb-1">
                The Last <span className="theme">Minute Deals</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="trend-box">
              <div className="row">
                <div className="col-lg-7">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 mb-4">
                      <div className="trend-item rounded box-shadow">
                        <div className="trend-image position-relative">
                          <img
                            src="images/trending/trending1.jpg"
                            alt="image"
                            className=""
                          />
                          <div className="color-overlay" />
                        </div>
                        <div className="trend-content p-4 pt-5 position-relative bg-white">
                          <div className="trend-meta bg-theme white px-3 py-2 rounded">
                            <div className="entry-author">
                              <i className="icon-calendar" />
                              <span className="fw-bold"> 4 Days Tours</span>
                            </div>
                          </div>
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Spain
                          </h5>
                          <h3 className="mb-1">
                            <a href="grid-leftfilter.html">
                              Barcelona city beach
                            </a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(21)</span>
                          </div>
                          <p className="border-b pb-2 mb-2">
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $220.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 mb-4">
                      <div className="trend-item rounded box-shadow">
                        <div className="trend-image position-relative">
                          <img
                            src="images/trending/trending2.jpg"
                            alt="image"
                            className=""
                          />
                          <div className="color-overlay" />
                        </div>
                        <div className="trend-content p-4 pt-5 position-relative bg-white">
                          <div className="trend-meta bg-theme white px-3 py-2 rounded">
                            <div className="entry-author">
                              <i className="icon-calendar" />
                              <span className="fw-bold"> 7 Days Tours</span>
                            </div>
                          </div>
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Indonesia
                          </h5>
                          <h3 className="mb-1">
                            <a href="grid-leftfilter.html">Bali Province</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(11)</span>
                          </div>
                          <p className="border-b pb-2 mb-2">
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $210.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 mb-4">
                      <div className="trend-item rounded box-shadow">
                        <div className="trend-image position-relative">
                          <img
                            src="images/trending/trending3.jpg"
                            alt="image"
                            className=""
                          />
                          <div className="color-overlay" />
                        </div>
                        <div className="trend-content p-4 pt-5 position-relative bg-white">
                          <div className="trend-meta bg-theme white px-3 py-2 rounded">
                            <div className="entry-author">
                              <i className="icon-calendar" />
                              <span className="fw-bold"> 3 Days Tours</span>
                            </div>
                          </div>
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Russia
                          </h5>
                          <h3 className="mb-1">
                            <a href="grid-leftfilter.html">Red City Land</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(25)</span>
                          </div>
                          <p className="border-b pb-2 mb-2">
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $120.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 mb-4">
                      <div className="trend-item rounded box-shadow">
                        <div className="trend-image position-relative">
                          <img
                            src="images/trending/trending4.jpg"
                            alt="image"
                            className=""
                          />
                          <div className="color-overlay" />
                        </div>
                        <div className="trend-content p-4 pt-5 position-relative bg-white">
                          <div className="trend-meta bg-theme white px-3 py-2 rounded">
                            <div className="entry-author">
                              <i className="icon-calendar" />
                              <span className="fw-bold"> 5 Days Tours</span>
                            </div>
                          </div>
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Bangladesh
                          </h5>
                          <h3 className="mb-1">
                            <a href="grid-leftfilter.html">Cox's bazar Beach</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(32)</span>
                          </div>
                          <p className="border-b pb-2 mb-2">
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $100.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 mb-4">
                  <div className="trend-item1 rounded box-shadow mb-4">
                    <div className="trend-image position-relative">
                      <img
                        src="images/trending/trendingb-2.jpg"
                        alt="image"
                        className=""
                      />
                      <div className="trend-content1 p-4">
                        <h5 className="theme1 mb-1">
                          <i className="flaticon-location-pin" /> Norway
                        </h5>
                        <h3 className="mb-1 white">
                          <a href="grid-leftfilter.html" className="white">
                            Norway Lake
                          </a>
                        </h3>
                        <div className="rating-main d-flex align-items-center pb-2">
                          <div className="rating">
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                          </div>
                          <span className="ms-2 white">(16)</span>
                        </div>
                        <div className="entry-meta d-flex align-items-center justify-content-between">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0 white">
                              <span className="theme1 fw-bold fs-5">
                                {" "}
                                $180.00
                              </span>{" "}
                              | Per person
                            </p>
                          </div>
                          <div className="entry-author">
                            <i className="icon-calendar white" />
                            <span className="fw-bold white"> 6 Days Tours</span>
                          </div>
                        </div>
                      </div>
                      <div className="overlay" />
                    </div>
                  </div>
                  <div className="trend-item1 rounded box-shadow mb-4">
                    <div className="trend-image position-relative">
                      <img
                        src="images/trending/trending-large.jpg"
                        alt="image"
                        className=""
                      />
                      <div className="trend-content1 p-4">
                        <h5 className="theme1 mb-1">
                          <i className="flaticon-location-pin" /> Egpyt
                        </h5>
                        <h3 className="mb-1 white">
                          <a href="grid-leftfilter.html" className="white">
                            Pyramid Land
                          </a>
                        </h3>
                        <div className="rating-main d-flex align-items-center pb-2">
                          <div className="rating">
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                          </div>
                          <span className="ms-2 white">(16)</span>
                        </div>
                        <div className="entry-meta d-flex align-items-center justify-content-between">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0 white">
                              <span className="theme1 fw-bold fs-5">
                                {" "}
                                $180.00
                              </span>{" "}
                              | Per person
                            </p>
                          </div>
                          <div className="entry-author">
                            <i className="icon-calendar white" />
                            <span className="fw-bold white"> 6 Days Tours</span>
                          </div>
                        </div>
                      </div>
                      <div className="overlay" />
                    </div>
                  </div>
                  <div className="trend-item1 rounded box-shadow">
                    <div className="trend-image position-relative">
                      <img
                        src="images/trending/trendingb-1.jpg"
                        alt="image"
                        className=""
                      />
                      <div className="trend-content1 p-4">
                        <h5 className="theme1 mb-1">
                          <i className="flaticon-location-pin" /> Usa
                        </h5>
                        <h3 className="mb-1 white">
                          <a href="grid-leftfilter.html" className="white">
                            New York City
                          </a>
                        </h3>
                        <div className="rating-main d-flex align-items-center pb-2">
                          <div className="rating">
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                            <span className="fa fa-star checked" />
                          </div>
                          <span className="ms-2 white">(12)</span>
                        </div>
                        <div className="entry-meta d-flex align-items-center justify-content-between">
                          <div className="entry-author d-flex align-items-center">
                            <p className="mb-0 white">
                              <span className="theme1 fw-bold fs-5">
                                {" "}
                                $140.00
                              </span>{" "}
                              | Per person
                            </p>
                          </div>
                          <div className="entry-author">
                            <i className="icon-calendar white" />
                            <span className="fw-bold white"> 3 Days Tours</span>
                          </div>
                        </div>
                      </div>
                      <div className="overlay" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Last Minute Deal Ends */}
        {/* about-us starts */}
        <section
          className="about-us pt-6"
          style={{
            backgroundImage: "url(images/background_pattern.png)",
            backgroundPosition: "bottom right",
          }}
        >
          <div className="container">
            <div className="about-image-box">
              <div className="row d-flex align-items-center justify-content-between">
                <div className="col-lg-6 ps-4">
                  <div className="about-content text-center text-lg-start">
                    <h4 className="theme d-inline-block mb-0">
                      Get To Know Us
                    </h4>
                    <h2 className="border-b mb-2 pb-1">
                      Explore All Tour of the world with us.
                    </h2>
                    <p className="border-b mb-2 pb-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      <br />
                      <br />
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidatat non proident, sunt in culpa qui
                      officia deserunt mollit anim id est laborum.
                    </p>
                    <div className="about-listing">
                      <ul className="d-flex justify-content-between">
                        <li>
                          <i className="icon-location-pin theme" /> Tour Guide
                        </li>
                        <li>
                          <i className="icon-briefcase theme" /> Friendly Price
                        </li>
                        <li>
                          <i className="icon-folder theme" /> Reliable Tour
                          Package
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4 pe-4">
                  <div
                    className="about-image"
                    style={{ animation: "none", background: "transparent" }}
                  >
                    <img src="images/travel.png" alt="" />
                  </div>
                </div>
                <div className="col-lg-12">
                  {/* Counter */}
                  <div className="counter-main w-75 float-start z-index3 position-relative">
                    <div className="counter p-4 pb-0 box-shadow bg-white rounded mt-minus">
                      <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                          <div className="counter-item border-end pe-4">
                            <div className="counter-content">
                              <h2 className="value mb-0 theme">20</h2>
                              <span className="m-0">Years Experiences</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                          <div className="counter-item border-end pe-4">
                            <div className="counter-content">
                              <h2 className="value mb-0 theme">530</h2>
                              <span className="m-0">Tour Packages</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                          <div className="counter-item border-end pe-4">
                            <div className="counter-content">
                              <h2 className="value mb-0 theme">850</h2>
                              <span className="m-0">Happy Customers</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 mb-4">
                          <div className="counter-item">
                            <div className="counter-content">
                              <h2 className="value mb-0 theme">320</h2>
                              <span className="m-0">Award Winning</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* End Counter */}
                </div>
              </div>
            </div>
          </div>
          <div className="white-overlay" />
        </section>
        {/* about-us ends */}
        {/* our teams starts */}
        <section className="our-team pb-6 pt-4">
          <div
            className="section-shape section-shape1"
            style={{ backgroundImage: "url(images/shape8.png)" }}
          />
          <div className="container">
            <div className="section-title mb-6 w-75 mx-auto text-center">
              <h4 className="mb-1 theme1">Tour Guides</h4>
              <h2 className="mb-1">
                Meet Our <span className="theme">Excellent Guides</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="team-main">
              <div className="row banner-slider">
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-list rounded">
                    <div className="team-image">
                      <img src="images/team/img1.jpg" alt="team" />
                    </div>
                    <div className="team-content text-center p-3 bg-theme">
                      <h4 className="mb-0 white">Salmon Thuir</h4>
                      <p className="mb-0 white">Senior Agent</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-list rounded">
                    <div className="team-image">
                      <img src="images/team/img2.jpg" alt="team" />
                    </div>
                    <div className="team-content text-center p-3 bg-theme">
                      <h4 className="mb-0 white">Horke Pels</h4>
                      <p className="mb-0 white">Head Officer</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-list rounded">
                    <div className="team-image">
                      <img src="images/team/img4.jpg" alt="team" />
                    </div>
                    <div className="team-content text-center p-3 bg-theme">
                      <h4 className="mb-0 white">Solden kalos</h4>
                      <p className="mb-0 white">Supervisor</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-list rounded">
                    <div className="team-image">
                      <img src="images/team/img3.jpg" alt="team" />
                    </div>
                    <div className="team-content text-center p-3 bg-theme">
                      <h4 className="mb-0 white">Nelson Bam</h4>
                      <p className="mb-0 white">Quality Assurance</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-list rounded">
                    <div className="team-image">
                      <img src="images/team/img4.jpg" alt="team" />
                    </div>
                    <div className="team-content text-center bg-theme p-3">
                      <h4 className="mb-0 white">Cacics Coold</h4>
                      <p className="mb-0 white">Asst. Manager</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* our teams Ends */}
        {/* offer Packages Starts */}
        <section
          className="trending pb-0 pt-0"
          style={{ backgroundColor: "#fdfdfd" }}
        >
          <div className="container">
            <div className="section-title mb-6 w-75 mx-auto text-center">
              <h4 className="mb-1 theme1">Top Offers</h4>
              <h2 className="mb-1">
                Special <span className="theme">Offers &amp; Discount </span>{" "}
                Packages
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="trend-box">
              <div className="row">
                <div className="col-lg-6 mb-4">
                  <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                    <div className="row m-0">
                      <div className="col-lg-5 col-md-4 ps-0">
                        <div className="trend-item2">
                          <a
                            href="#"
                            style={{
                              backgroundImage:
                                "url(images/trending/trending1.jpg)",
                            }}
                          />
                          <div className="ribbon ribbon-top-left">
                            <span className="fw-bold">20% OFF</span>
                          </div>
                          <div className="color-overlay" />
                        </div>
                      </div>
                      <div className="col-lg-7 col-md-8">
                        <div className="trend-content py-3 position-relative">
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Croatia
                          </h5>
                          <h3 className="mb-1">
                            <a href="grid-leftfilter.html">Piazza Castello</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(12)</span>
                          </div>
                          <p>
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="trend-meta border-b pb-2 mb-2">
                            <div className="entry-author theme">
                              <i className="icon-calendar" />
                              <span> 9 Days Tours</span>
                            </div>
                          </div>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $170.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                    <div className="row m-0">
                      <div className="col-lg-5 col-md-4 ps-0">
                        <div className="trend-item2">
                          <a
                            href="#"
                            style={{
                              backgroundImage:
                                "url(images/trending/trending2.jpg)",
                            }}
                          />
                          <div className="ribbon ribbon-top-left">
                            <span className="fw-bold">10% OFF</span>
                          </div>
                          <div className="color-overlay" />
                        </div>
                      </div>
                      <div className="col-lg-7 col-md-8">
                        <div className="trend-content py-3 position-relative">
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Greece
                          </h5>
                          <h3 className="mb-1">
                            <a href="grid-leftfilter.html">Santorini, Oia</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(18)</span>
                          </div>
                          <p>
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="trend-meta border-b pb-2 mb-2">
                            <div className="entry-author theme">
                              <i className="icon-calendar" />
                              <span> 7 Days Tours</span>
                            </div>
                          </div>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $210.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                    <div className="row m-0">
                      <div className="col-lg-5 col-md-4 ps-0">
                        <div className="trend-item2">
                          <a
                            href="#"
                            style={{
                              backgroundImage:
                                "url(images/trending/trending3.jpg)",
                            }}
                          />
                          <div className="ribbon ribbon-top-left">
                            <span className="fw-bold">30% OFF</span>
                          </div>
                          <div className="color-overlay" />
                        </div>
                      </div>
                      <div className="col-lg-7 col-md-8">
                        <div className="trend-content py-3 position-relative">
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Norway
                          </h5>
                          <h3 className="mb-1">
                            <a href="grid-leftfilter.html">Norway Lake</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(17)</span>
                          </div>
                          <p>
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="trend-meta border-b pb-2 mb-2">
                            <div className="entry-author theme">
                              <i className="icon-calendar" />
                              <span> 6 Days Tours</span>
                            </div>
                          </div>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $185.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className="trend-full bg-white rounded box-shadow overflow-hidden">
                    <div className="row m-0">
                      <div className="col-lg-5 col-md-4 ps-0">
                        <div className="trend-item2">
                          <a
                            href="#"
                            style={{
                              backgroundImage:
                                "url(images/trending/trending4.jpg)",
                            }}
                          />
                          <div className="ribbon ribbon-top-left">
                            <span className="fw-bold">15% OFF</span>
                          </div>
                          <div className="color-overlay" />
                        </div>
                      </div>
                      <div className="col-lg-7 col-md-8">
                        <div className="trend-content py-3 position-relative">
                          <h5 className="theme mb-1">
                            <i className="flaticon-location-pin" /> Maldives
                          </h5>
                          <h3 className="mb-1">
                            <a href="grid-leftfilter.html">Hurawalhi Island</a>
                          </h3>
                          <div className="rating-main d-flex align-items-center pb-2">
                            <div className="rating">
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                              <span className="fa fa-star checked" />
                            </div>
                            <span className="ms-2">(32)</span>
                          </div>
                          <p>
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum
                          </p>
                          <div className="trend-meta border-b pb-2 mb-2">
                            <div className="entry-author theme">
                              <i className="icon-calendar" />
                              <span> 4 Days Tours</span>
                            </div>
                          </div>
                          <div className="entry-meta">
                            <div className="entry-author d-flex align-items-center">
                              <p className="mb-0">
                                <span className="theme fw-bold fs-5">
                                  {" "}
                                  $260.00
                                </span>{" "}
                                | Per person
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* offer Packages Ends */}
        {/* Discount action starts */}
        <section
          className="discount-action pt-4"
          style={{
            backgroundImage: "url(images/section-bg1.png)",
            backgroundPosition: "center",
          }}
        >
          <div
            className="section-shape section-shape1 top-inherit bottom-0"
            style={{ backgroundImage: "url(images/shape8.png)" }}
          />
          <div className="container">
            <div className="call-banner rounded pt-10 pb-14">
              <div className="call-banner-inner w-75 mx-auto text-center px-5">
                <div className="trend-content-main">
                  <div className="trend-content mb-5 pb-2 px-5">
                    <h5 className="mb-1 theme">Love Where Your're Going</h5>
                    <h2>
                      <a href="detail-fullwidth.html">
                        Explore Your Life,{" "}
                        <span className="theme1"> Travel Where You Want!</span>
                      </a>
                    </h2>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua.
                    </p>
                  </div>
                  <div className="video-button text-center position-relative">
                    <div className="call-button text-center">
                      <button
                        type="button"
                        className="play-btn js-video-button"
                        data-video-id={152879427}
                        data-channel="vimeo"
                      >
                        <i className="fa fa-play bg-blue" />
                      </button>
                    </div>
                    <div className="video-figure" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="white-overlay" />
        </section>
        {/* Discount action Ends */}
        {/* testomonial start */}
        <section className="testimonial pt-4">
          <div className="container">
            <div className="section-title mb-6 text-center w-75 mx-auto">
              <h4 className="mb-1 theme1">Our Testimonails</h4>
              <h2 className="mb-1">
                Good Reviews By <span className="theme">Clients</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="testimonial-in">
              <div className="row review-slider1">
                <div className="col-sm-4 item">
                  <div className="testimonial-item1 rounded bg-white p-4 py-5 box-shadow border text-center mx-2">
                    <div className="details mb-4">
                      <p className="m-0">
                        <i className="fa fa-quote-left me-2 fs-1" />
                        Lorem Ipsum is simply dummy text of the printing
                        andypesetting industry. Lorem ipsum a simple Lorem Ipsum
                        has been the industry's standard dummy hic et quidem.
                        Dignissimos maxime velit unde inventore quasi vero
                        dolorem.
                      </p>
                    </div>
                    <div className="author-info mt-2">
                      <a href="#">
                        <img src="images/testimonial/img1.jpg" alt="" />
                      </a>
                      <div className="author-title ms-3">
                        <h5 className="m-0 theme">Lonell South</h5>
                        <span>Accountant</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-4 item">
                  <div className="testimonial-item1 rounded bg-white p-4 py-5 box-shadow border text-center mx-2">
                    <div className="details mb-4">
                      <p className="m-0">
                        <i className="fa fa-quote-left me-2 fs-1" />
                        Lorem Ipsum is simply dummy text of the printing
                        andypesetting industry. Lorem ipsum a simple Lorem Ipsum
                        has been the industry's standard dummy hic et quidem.
                        Dignissimos maxime velit unde inventore quasi vero
                        dolorem.
                      </p>
                    </div>
                    <div className="author-info mt-2">
                      <a href="#">
                        <img src="images/testimonial/img2.jpg" alt="" />
                      </a>
                      <div className="author-title ms-3">
                        <h5 className="m-0 theme">Kelton Mick</h5>
                        <span>Manager</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-4 item">
                  <div className="testimonial-item1 rounded bg-white p-4 py-5 box-shadow border text-center mx-2">
                    <div className="details mb-4">
                      <p className="m-0">
                        <i className="fa fa-quote-left me-2 fs-1" />
                        Lorem Ipsum is simply dummy text of the printing
                        andypesetting industry. Lorem ipsum a simple Lorem Ipsum
                        has been the industry's standard dummy hic et quidem.
                        Dignissimos maxime velit unde inventore quasi vero
                        dolorem.
                      </p>
                    </div>
                    <div className="author-info mt-2">
                      <a href="#">
                        <img src="images/testimonial/img3.jpg" alt="" />
                      </a>
                      <div className="author-title ms-3">
                        <h5 className="m-0 theme">Jared Erondu</h5>
                        <span>Supervisor</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* testimonial ends */}
        {/* recent-articles starts */}
        <section className="trending recent-articles pb-6 pt-0">
          <div className="container">
            <div className="section-title mb-6 w-75 mx-auto text-center">
              <h4 className="mb-1 theme1">Our Blogs Offers</h4>
              <h2 className="mb-1">
                Recent <span className="theme">Articles &amp; Posts</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="recent-articles-inner">
              <div className="row">
                <div className="col-lg-4">
                  <div className="trend-item box-shadow bg-white mb-4 rounded">
                    <div className="trend-image">
                      <img src="images/trending/trending10.jpg" alt="image" />
                    </div>
                    <div className="trend-content-main p-4">
                      <div className="trend-content">
                        <h5 className="theme mb-1">Technology</h5>
                        <h4>
                          <a href="detail-1.html">
                            How a developer duo at Deutsche Bank keep remote
                            alive.
                          </a>
                        </h4>
                        <p className="mb-3">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod
                        </p>
                        <div className="entry-meta d-flex align-items-center justify-content-between">
                          <div className="entry-author">
                            <img
                              src="images/reviewer/2.jpg"
                              alt=""
                              className="rounded-circle me-1"
                            />
                            <span>Sollmond Nell</span>
                          </div>
                          <div className="entry-button d-flex align-items-center">
                            <a href="#" className="nir-btn">
                              Read More
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="trend-item box-shadow bg-white mb-4 rounded">
                    <div className="trend-image">
                      <img src="images/trending/trending12.jpg" alt="image" />
                    </div>
                    <div className="trend-content-main p-4">
                      <div className="trend-content">
                        <h5 className="theme mb-1">Inspiration</h5>
                        <h4>
                          <a href="detail-1.html">
                            Inspire Runner with Autism Graces of Women's Running
                          </a>
                        </h4>
                        <p className="mb-3">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod
                        </p>
                        <div className="entry-meta d-flex align-items-center justify-content-between">
                          <div className="entry-author">
                            <img
                              src="images/reviewer/1.jpg"
                              alt=""
                              className="rounded-circle me-1"
                            />
                            <span>David Scott</span>
                          </div>
                          <div className="entry-button d-flex align-items-center">
                            <a href="#" className="nir-btn">
                              Read More
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="trend-item box-shadow bg-white mb-4 rounded">
                    <div className="trend-image">
                      <img src="images/trending/trending13.jpg" alt="image" />
                    </div>
                    <div className="trend-content-main p-4">
                      <div className="trend-content">
                        <h5 className="theme mb-1">Public</h5>
                        <h4>
                          <a href="detail-1.html">
                            Services To Grow Your Business Sell Affiliate
                            Products
                          </a>
                        </h4>
                        <p className="mb-3">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod
                        </p>
                        <div className="entry-meta d-flex align-items-center justify-content-between">
                          <div className="entry-author">
                            <img
                              src="images/reviewer/3.jpg"
                              alt=""
                              className="rounded-circle me-1"
                            />
                            <span>John Bolden</span>
                          </div>
                          <div className="entry-button d-flex align-items-center">
                            <a href="#" className="nir-btn">
                              Read More
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* recent-articles ends */}
        {/* partner starts */}
        <section className="our-partner pt-0 pb-6">
          <div className="container">
            <div className="section-title mb-6 w-75 mx-auto text-center">
              <h4 className="mb-1 theme1">Our Partners</h4>
              <h2 className="mb-1">
                Our Awesome <span className="theme">partners</span>
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div className="row align-items-center partner-in partner-slider">
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-1.png" alt="" />
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-5.png" alt="" />
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-2.png" alt="" />
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-3.png" alt="" />
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-4.png" alt="" />
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="partner-item p-4 py-2 rounded bg-lgrey">
                  <img src="images/cl-5.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* partner ends */}
      </>

      <SeoLinksSection />
      <Footer />
    </>
  );
}
